import queryString from 'query-string';

export const get_host = () => { 
    const parsed = queryString.parse( window.location.search );
    if( parsed.eaep /* short for `encoded api endpoint portal` */ ) {
        return atob(atob(parsed.eaep))
    }
    return parsed.host;
}
